$(function () {
    var cookieParam = 'y-real_username';
    function getCookie(name) {
        var start = document.cookie.indexOf(name + "=");
        var len = start + name.length + 1;
        if (( !start ) && ( name !== document.cookie.substring(0, name.length) )) {
            return null;
        }
        if (start === -1) return null;
        var end = document.cookie.indexOf(';', len);
        if (end === -1) end = document.cookie.length;
        return document.cookie.substring(len, end);
    }

    function setCookie(name, value) {
        var expires = new Date(2050, 1, 1);
        document.cookie = name + "=" + value + "; expires=" + expires.toGMTString() + "; domain=.ykt.ru; path=/";
    }

    var showModal = getCookie(cookieParam);
    var mainContainer = document.getElementById('y-name');
    if (mainContainer !== null && (showModal == null || showModal === 'hide') && document.location.hostname != 'pechka.ykt.ru') {
        mainContainer.style.display = 'none';
        var fragmentContainer = document.createDocumentFragment();
        var modalContainer = document.createElement('div');
        modalContainer.className = 'remodal y-name';
        modalContainer.setAttribute('data-remodal-id', 'modal');

        var closeBtn = document.createElement('button');
        closeBtn.className = 'remodal-close';
        closeBtn.setAttribute('data-remodal-action', 'close');
        modalContainer.appendChild(closeBtn);

        var logo = document.createElement('div');
        logo.className = 'y-name_logo';
        modalContainer.appendChild(logo);

        var page1 = document.createElement('div');
        page1.className = 'y-name_page';
        page1.id = 'y-page1';

        var page1Header = document.createElement('div');
        page1Header.className = 'y-name_header';

        var page1Title = document.createElement('div');
        page1Title.className = 'y-name_header_title';
        page1Title.innerHTML = 'В вашем профиле нет имени';
        page1Header.appendChild(page1Title);

        var page1Subtitle = document.createElement('div');
        page1Subtitle.className = 'y-name_header_subtitle';
        page1Subtitle.innerHTML = 'Давайте познакомимся?';
        page1Header.appendChild(page1Subtitle);

        page1.appendChild(page1Header);

        var page1Form = document.createElement('div');
        page1Form.className = 'y-name_form';

        var formInputFN = document.createElement('input');
        formInputFN.className = 'y-name_form_input';
        formInputFN.type = 'text';
        formInputFN.id = 'y-firstname';
        formInputFN.setAttribute("maxlength", "20");
        formInputFN.setAttribute('placeholder', 'Имя');
        formInputFN.setAttribute('autofocus', '');
        page1Form.appendChild(formInputFN);

        var formInputLN = document.createElement('input');
        formInputLN.className = 'y-name_form_input';
        formInputLN.type = 'text';
        formInputLN.id = 'y-lastname';
        formInputFN.setAttribute("maxlength", "20");
        formInputLN.setAttribute('placeholder', 'Фамилия');
        page1Form.appendChild(formInputLN);

        var formBtn = document.createElement('button');
        formBtn.className = 'y-name_form_btn';
        formBtn.id = 'y-save';
        formBtn.innerHTML = 'Добавить';
        page1Form.appendChild(formBtn);

        page1.appendChild(page1Form);

        var page1Footer = document.createElement('div');
        page1Footer.className = 'y-name_footer';

        var page1Woman = document.createElement('div');
        page1Woman.className = 'y-name_woman';
        page1Footer.appendChild(page1Woman);

        var page1Info = document.createElement('div');
        page1Info.className = 'y-name_info';
        page1Info.innerHTML = 'Наличие реального имени делает<br>общение дружелюбнее';
        page1Footer.appendChild(page1Info);

        page1.appendChild(page1Footer);

        modalContainer.appendChild(page1);

        var page2 = document.createElement('div');
        page2.className = 'y-name_page';
        page2.id = 'y-page2';

        var page2Header = document.createElement('div');
        page2Header.className = 'y-name_header';

        var page2Title = document.createElement('div');
        page2Title.className = 'y-name_header_title';
        page2Title.innerHTML = 'Приятно познакомиться,';

        var page2TitleUsername = document.createElement('span');
        page2TitleUsername.id = 'y-username';
        page2Title.appendChild(page2TitleUsername);

        page2Header.appendChild(page2Title);

        var page2Subtitle = document.createElement('div');
        page2Subtitle.className = 'y-name_header_subtitle';
        page2Subtitle.innerHTML = 'Вы всегда можете изменить имя в своем <a href="//id.ykt.ru/page/settings" target="_blank">профиле</a>';
        page2Header.appendChild(page2Subtitle);

        page2.appendChild(page2Header);

        var page2Form = document.createElement('div');
        page2Form.className = 'y-name_form';

        var formClose = document.createElement('button');
        formClose.className = 'y-name_form_btn remodal-confirm';
        formClose.setAttribute('data-remodal-action', 'confirm');
        formClose.innerHTML = 'Готово';
        page2Form.appendChild(formClose);

        page2.appendChild(page2Form);

        var page2Footer = document.createElement('div');
        page2Footer.className = 'y-name_footer';

        var page2Woman = document.createElement('div');
        page2Woman.className = 'y-name_woman';
        page2Footer.appendChild(page2Woman);

        var page2Info = document.createElement('div');
        page2Info.className = 'y-name_info';
        page2Info.innerHTML = 'Также вы можете привязать свою страницу <div class="y-name_social">'
            + '<a href="//oauth.vk.com/oauth/authorize?client_id=1877276&scope=email&response_type=code&redirect_uri=%2F%2Fid.ykt.ru%2Fpage%2Fvk_redirect" target="_blank"><svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 0 35 35"><g fill="#4A90E2"><path d="M17.5 35C7.8 35 0 27.2 0 17.5 0 7.8 7.8 0 17.5 0 27.2 0 35 7.8 35 17.5 35 27.2 27.2 35 17.5 35ZM27.9 24C27.9 23.9 27.8 23.9 27.8 23.8 27.4 23.1 26.7 22.3 25.6 21.3L25.6 21.3 25.5 21.3 25.5 21.2 25.5 21.2C25 20.8 24.7 20.5 24.6 20.3 24.3 20 24.3 19.7 24.4 19.4 24.5 19.1 24.9 18.6 25.5 17.9 25.8 17.5 26 17.1 26.2 16.9 27.6 15.1 28.1 14 28 13.5L27.9 13.4C27.9 13.3 27.7 13.3 27.5 13.2 27.3 13.1 27.1 13.1 26.8 13.2L23.4 13.2C23.4 13.2 23.3 13.2 23.2 13.2 23.1 13.2 23 13.2 23 13.2L23 13.3 22.9 13.3C22.9 13.3 22.9 13.4 22.8 13.4 22.8 13.5 22.7 13.5 22.7 13.6 22.3 14.6 21.9 15.4 21.4 16.2 21.2 16.7 20.9 17.1 20.7 17.4 20.4 17.8 20.2 18.1 20.1 18.2 19.9 18.4 19.7 18.5 19.6 18.6 19.5 18.7 19.4 18.8 19.3 18.7 19.2 18.7 19.2 18.7 19.1 18.7 19 18.6 18.9 18.5 18.8 18.4 18.8 18.3 18.7 18.1 18.7 18 18.7 17.8 18.7 17.6 18.7 17.5 18.7 17.4 18.7 17.2 18.7 16.9 18.7 16.7 18.7 16.5 18.7 16.5 18.7 16.2 18.7 15.9 18.7 15.5 18.7 15.2 18.7 14.9 18.7 14.7 18.7 14.5 18.7 14.3 18.7 14.1 18.7 13.9 18.7 13.7 18.7 13.6 18.7 13.4 18.6 13.3 18.6 13.2 18.5 13.1 18.4 13 18.3 12.9 18.2 12.8 18.1 12.8 18 12.8 17.5 12.7 17 12.6 16.4 12.6 14.9 12.6 14 12.7 13.6 12.9 13.4 13 13.3 13.1 13.1 13.2 13 13.4 13 13.5 13.1 13.5 13.6 13.6 13.9 13.7 14.1 14L14.1 14.1C14.2 14.2 14.3 14.4 14.3 14.7 14.4 14.9 14.4 15.2 14.4 15.5 14.5 16.1 14.5 16.5 14.4 16.9 14.4 17.3 14.3 17.6 14.3 17.9 14.3 18.1 14.2 18.3 14.1 18.4 14.1 18.5 14 18.6 14 18.7 14 18.7 14 18.7 14 18.7 13.8 18.8 13.7 18.8 13.6 18.8 13.5 18.8 13.4 18.7 13.2 18.6 13.1 18.5 12.9 18.4 12.8 18.2 12.6 18 12.4 17.7 12.2 17.4 12 17 11.8 16.6 11.5 16.2L11.3 15.9C11.2 15.6 11.1 15.3 10.9 14.9 10.7 14.5 10.5 14.1 10.3 13.7 10.3 13.6 10.2 13.4 10.1 13.4L10 13.3C10 13.3 9.9 13.3 9.8 13.2 9.7 13.2 9.6 13.2 9.5 13.2L6.3 13.2C6 13.2 5.8 13.2 5.7 13.4L5.6 13.5C5.6 13.5 5.6 13.6 5.6 13.6 5.6 13.7 5.6 13.8 5.7 14 6.1 15 6.6 16.1 7.2 17.1 7.7 18.1 8.2 18.9 8.6 19.5 9 20.1 9.4 20.7 9.9 21.2 10.3 21.8 10.6 22.1 10.7 22.3 10.8 22.4 10.9 22.6 11 22.6L11.3 22.9C11.5 23.1 11.8 23.3 12.1 23.6 12.5 23.8 12.9 24.1 13.3 24.3 13.8 24.6 14.3 24.8 14.9 24.9 15.4 25.1 16 25.2 16.6 25.1L17.9 25.1C18.2 25.1 18.4 25 18.5 24.9L18.6 24.8C18.6 24.8 18.6 24.7 18.7 24.6 18.7 24.5 18.7 24.4 18.7 24.3 18.7 24 18.7 23.7 18.8 23.4 18.8 23.1 18.9 22.9 19 22.8 19 22.7 19.1 22.6 19.2 22.5 19.3 22.4 19.4 22.3 19.4 22.3 19.5 22.3 19.5 22.3 19.5 22.3 19.7 22.2 19.9 22.3 20.2 22.4 20.4 22.6 20.7 22.8 20.9 23.1 21.1 23.4 21.4 23.7 21.7 24 22 24.3 22.3 24.6 22.5 24.7L22.7 24.9C22.9 25 23.1 25 23.3 25.1 23.6 25.2 23.8 25.2 24 25.2L27 25.1C27.3 25.1 27.5 25.1 27.7 25 27.8 24.9 27.9 24.8 28 24.7 28 24.6 28 24.4 28 24.3 27.9 24.1 27.9 24 27.9 24Z"/></g></svg></a>'
            + '&nbsp;&nbsp;<a href="https://www.facebook.com/dialog/oauth?client_id=240223402676491&scope=email&locale=ru_RU&redirect_uri=%2F%2Fid.ykt.ru%2Fpage%2Ffb_redirect" target="_blank"><svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 0 35 35"><g fill="#005686"><path d="M17.5 35C7.8 35 0 27.2 0 17.5 0 7.8 7.8 0 17.5 0 27.2 0 35 7.8 35 17.5 35 27.2 27.2 35 17.5 35ZM22 8.4L19.3 8.4C16.3 8.4 14.3 10.4 14.3 13.5L14.3 15.8 11.6 15.8C11.4 15.8 11.2 16 11.2 16.3L11.2 19.7C11.2 19.9 11.4 20.1 11.6 20.1L14.3 20.1 14.3 28.7C14.3 28.9 14.5 29.1 14.7 29.1L18.3 29.1C18.5 29.1 18.7 28.9 18.7 28.7L18.7 20.1 21.9 20.1C22.1 20.1 22.3 19.9 22.3 19.7L22.3 16.3C22.3 16.2 22.2 16.1 22.2 16 22.1 15.9 22 15.8 21.9 15.8L18.7 15.8 18.7 13.9C18.7 12.9 18.9 12.4 20.2 12.4L22 12.4C22.2 12.4 22.4 12.2 22.4 12L22.4 8.8C22.4 8.6 22.2 8.4 22 8.4Z"/></g></svg></a>'
            + '</div>';
        page2Footer.appendChild(page2Info);

        page2.appendChild(page2Footer);

        modalContainer.appendChild(page2);

        fragmentContainer.appendChild(modalContainer);
        mainContainer.appendChild(fragmentContainer);

        /* напоминалка */
        var popupContainer = document.createElement('div');
        popupContainer.className = 'y-popup';
        popupContainer.style.display = 'none';

        var popupWoman = document.createElement('div');
        popupWoman.className = 'y-popup_woman';
        popupContainer.appendChild(popupWoman);

        var popupBody = document.createElement('div');
        popupBody.className = 'y-popup_body';

        var popupText = document.createElement('div');
        popupText.className = 'y-popup_text';
        popupText.innerHTML = 'В вашем профиле нет имени';
        popupBody.appendChild(popupText);

        var popupOpenBtn = document.createElement('button');
        popupOpenBtn.className = 'y-popup_open';
        popupOpenBtn.innerHTML = 'Добавить';
        popupBody.appendChild(popupOpenBtn);

        var popupCloseBtn = document.createElement('button');
        popupCloseBtn.className = 'y-popup_close';
        popupCloseBtn.innerHTML = 'Закрыть';
        popupBody.appendChild(popupCloseBtn);

        popupContainer.appendChild(popupBody);

        document.body.appendChild(popupContainer);

        var $popupContainer = $(popupContainer);
        var $mainContainer = $(mainContainer);
        var $form = $(page1Form);
        var $firstName = $(formInputFN);
        var $lastName = $(formInputLN);
        var $page2TitleUsername = $(page2TitleUsername);
        var $page1 = $(page1);
        var $page2 = $(page2);

        var isAndroid = (navigator.userAgent.match(/Android/i) && navigator.userAgent.match(/Mobile/i));
        var isIos = navigator.userAgent.match(/iPhone/i);

        var instModal = $('[data-remodal-id=modal]').remodal({
            closeOnOutsideClick: false
            ,hashTracking: false
        });

        $.ajax({
            url: '//id.ykt.ru/api/getCurrentUserInfo',
            dataType: 'jsonp',
            jsonp: "jsonp",
            success: function (response) {
                if (!response.isAnonymous && response.isNameEmpty) {
                    $mainContainer.show();
                    if (getCookie(cookieParam) === 'hide') {
                        showPopup();
                    } else {
                        instModal.open();
                        ga('send', 'event', 'real_name', 'view');
                    }
                }
            }
        });

        $firstName.on('keydown', function () {
            $(this).removeClass('required');
            $form.removeClass('required');
        });
        $lastName.on('keydown', function () {
            $(this).removeClass('required');
            $form.removeClass('required');
        });

        $(popupCloseBtn).on('click', function () {
            setCookie(cookieParam, "closed");
            hidePopup();
        });

        $(popupOpenBtn).on('click', function () {
            hidePopup();
            instModal.open();
        });

        function hidePopup() {
            $popupContainer.animate({opacity:0, bottom: '-120px'}, 200, function () {
                $(this).hide().css({opacity:0})
            });
        }
        function showPopup() {
            $popupContainer.show().animate({opacity:1, bottom: '10px'}, 200);
        }

        $(formBtn).on('click', function () {
            var firstNameVal = ($firstName.val()).trim();
            var lastNameVal = ($lastName.val()).trim();
            if (firstNameVal === '') {
                $firstName.addClass('required');
                $form.addClass('required');
            }
            if (lastNameVal === '') {
                $lastName.addClass('required');
                $form.addClass('required');
            }
            if (firstNameVal !== '' && lastNameVal !== '') {
                if (typeof jQuery != 'undefined') {
                    if (jQuery.fn.jquery == '1.8.3' || jQuery.fn.jquery == '1.7.2') {
                        $.ajax({
                            url: '//id.ykt.ru/api/setData',
                            type: 'POST',
                            xhrFields: {
                                withCredentials: true
                            },
                            data: {
                                lastname: lastNameVal,
                                firstname: firstNameVal,
                                site: document.location.hostname,
                                jsonp: 'jsonp'
                            },
                            success: function (response) {
                                if (response.result === 'ok') {
                                    $page1.hide();
                                    $page2.show();
                                    setCookie(cookieParam, "closed");
                                    $page2TitleUsername.html(' ' + firstNameVal);
                                    ga('send', 'event', 'real_name', 'click');
                                    $.ajax({
                                        url: '//bit.ly/2tADyQZ',
                                        success: function () {

                                        }
                                    });
                                } else {
                                    alert("Извините, что-то пошло не так.");
                                }
                            },
                            error: function () {
                                alert("Извините, что-то пошло не так.");
                            }
                        });
                    } else {
                        $.ajax({
                            url: '//id.ykt.ru/api/setData',
                            method: 'POST',
                            xhrFields: {
                                withCredentials: true
                            },
                            data: {
                                lastname: lastNameVal,
                                firstname: firstNameVal,
                                site: document.location.hostname,
                                jsonp: 'jsonp'
                            },
                            success: function (response) {
                                if (response.result === 'ok') {
                                    $page1.hide();
                                    $page2.show();
                                    setCookie(cookieParam, "closed");
                                    $page2TitleUsername.html(' ' + firstNameVal);
                                    ga('send', 'event', 'real_name', 'click');
                                    $.ajax({
                                        url: '//bit.ly/2tADyQZ',
                                        success: function () {

                                        }
                                    });
                                } else {
                                    alert("Извините, что-то пошло не так.");
                                }
                            },
                            error: function () {
                                alert("Извините, что-то пошло не так.");
                            }
                        });
                    }
                }
            }
        });

        $(document).on('closed', '.y-name', function (e) {
            if (e.reason) {
                setCookie(cookieParam, "closed");
            } else {
                if (!isAndroid && !isIos) {
                    setCookie(cookieParam, "hide");
                    showPopup();
                } else {
                    setCookie(cookieParam, "closed");
                }
            }
        });
    }
});